export type FetchErrorKind = "noData" | "server" | "network";

export function classifyFetchError(error: unknown): FetchErrorKind {
    if (error instanceof Response) {
        return error.status === 400 ? "noData" : "server";
    }

    return "network";
}
